import { Outlet } from 'react-router-dom';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';

// project imports
import { useMenu } from 'context/menu-context';
import Header from '../shared/Header';
import Sidebar from '../shared/Sidebar';
import MenuList from './MenuList';
import { drawerWidth } from 'utils/constant';
import { SET_MENU } from 'utils/actions';

// styles
const Main = styled('main', { shouldForwardProp: prop => prop !== 'open' })(({ theme, open }) => ({
	...theme.typography.mainContent,
	...(!open && {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		[theme.breakpoints.up('md')]: {
			marginLeft: -(drawerWidth - 10),
			width: `calc(100% - ${drawerWidth}px)`,
		},
		[theme.breakpoints.down('md')]: {
			marginLeft: '10px',
			width: `calc(100% - ${drawerWidth}px)`,
			padding: '12px',
		},
		[theme.breakpoints.down('sm')]: {
			marginLeft: '10px',
			width: `calc(100% - ${drawerWidth}px)`,
			padding: '12px',
			marginRight: '10px',
		},
	}),
	...(open && {
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginLeft: 0,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		width: `calc(100% - ${drawerWidth}px)`,
		[theme.breakpoints.down('md')]: {
			marginLeft: '10px',
		},
		[theme.breakpoints.down('sm')]: {
			marginLeft: '10px',
		},
	}),
}));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
	const theme = useTheme();
	const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
	// Handle left drawer
	const { state: customization, dispatch } = useMenu();
	const leftDrawerOpened = customization.opened;
	const handleLeftDrawerToggle = () => {
		dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
	};

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			{/* header */}
			<AppBar
				enableColorOnDark
				position="fixed"
				color="inherit"
				elevation={2}
				sx={{
					bgcolor: theme.palette.background.paper,
					transition: leftDrawerOpened ? theme.transitions.create('width') : 'none',
				}}
			>
				<Toolbar sx={{ padding: '6px' }}>
					<Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
				</Toolbar>
			</AppBar>

			{/* drawer */}
			<Sidebar drawerOpen={!matchDownMd ? leftDrawerOpened : !leftDrawerOpened} drawerToggle={handleLeftDrawerToggle}>
				<MenuList />
			</Sidebar>

			{/* main content */}
			<Main theme={theme} open={leftDrawerOpened}>
				<Outlet />
			</Main>
		</Box>
	);
};

export default MainLayout;
